// hooks/useNavigationTracker.ts
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

// Define paths that should trigger data clearing
const DASHBOARD_PATHS = [
  '/v1/new-order',
  '/v1/CarDashboard', 
  '/v1/order-list',
  '/v1/employee/new-order',
  '/v1/employee/order-list',
  '/'
];

const CARWASH_PATHS = [
  '/carwash',
  '/car-payment'
];

export const useNavigationTracker = (onNavigateAway?: () => void) => {
  const location = useLocation();
  const prevPathRef = useRef<string>('');

  useEffect(() => {
    const currentPath = location.pathname;
    const prevPath = prevPathRef.current;

    // Check if navigating FROM carwash TO dashboard/order
    const isLeavingCarWash = CARWASH_PATHS.some(path => prevPath.includes(path));
    const isGoingToDashboard = DASHBOARD_PATHS.some(path => currentPath.includes(path));
    
    if (isLeavingCarWash && isGoingToDashboard) {
      // Call the cleanup function
      onNavigateAway?.();
    }

    // Update previous path
    prevPathRef.current = currentPath;
  }, [location, onNavigateAway]);

  return {
    currentPath: location.pathname,
  };
};